/**
 * Model for favorite airport user data
 */
export class FavoriteAirport {
  /**
   * Unique identifier of the user data record that stores this favorite airport.
   */
  userDataId: number;

  /**
   * Airport identifier
   */
  identifier: string;

  /**
   * Parses favorite airport data from the web service
   * @param data Favorite airport data as returned by the API
   * @returns {FavoriteAirport} Parsed favorite airport data
   */
  static parse(data: any): FavoriteAirport {
    return Object.assign(new FavoriteAirport(), {
      userDataId: data.userDataId,
      identifier: data.identifier
    });
  }
}
